module.exports = __webpack_public_path__ + "static/media/Metabolic.b30bf661.jpg";